const goods = {
  state: {
    goodid: '',
    orderid: '',
    stockgoodid: '',
    couponid: '',
    coupongoodlist: [],
    goodlist: [
      { id: '2', // 商品号
        type: 'fengyi',
        name: 'xxx', // 商品名称
        dic: '22222',
        slimg: [
          {
            picid: 1,
            picurl: ''
          },
          {
            picid: 2,
            picurl: ''
          }
        ],
        hbimg: [
          {
            picid: 1,
            picurl: ''
          },
          {
            picid: 2,
            picurl: ''
          }
        ],
        xqimg: [
          {
            picid: 1,
            picurl: ''
          },
          {
            picid: 2,
            picurl: ''
          }
        ],
        bj: [
          {
            id: '3',
            name: '领口',
            ys: [
              {
                name: '圆领',
                picurl: '../../static/img/bg.jpg',
                ysid: 1,
                sm: ''// 说明
              },
              {
                name: '鸡心领',
                picurl: '',
                ysid: 2,
                sm: ''// 说明
              }
            ]
          },
          {
            id: '4',
            name: '袖口纽扣',
            ys: [
              {
                name: '单纽扣',
                picurl: '',
                ysid: 3,
                sm: ''// 说明
              },
              {
                name: '双纽扣',
                picurl: '',
                ysid: 5,
                sm: ''// 说明
              },
              {
                name: '三纽扣',
                picurl: '',
                ysid: 6,
                sm: ''// 说明
              }
            ]
          }
        ],
        kxz: [
          {
            id: '3',
            name: '左袖口',
            sub: [
              {
                bjname: '领口',
                bjid: 1,
                ysname: '圆领',
                ysid: 1

              },
              {
                bjname: '领口',
                bjid: 1,
                ysname: '鸡心领',
                ysid: 2
              }
            ],
            picid: 1,
            picurl: ''
          }
        ],
        mrk: [
          {id: 1,
            item: [
              { bjid: 1,
                bjys: 1},
              { bjid: 2,
                bjys: 3}
            ]
          },
          {id: 2,
            item: [
              { bjid: 1,
                bjys: 2},
              { bjid: 2,
                bjys: 3}
            ]
          }
        ],
        xzcolor: [
          {
            id: 1,
            colorname: '象牙白',
            picid: 1,
            picurl: ''
          }
        ],
        zc: {
          zcnum: 20,
          fhtime: 10,
          zccashtype: 1,
          price: 3000,
          tkkd: 20
        },
        time: '1'
      }
    ]
  },
  mutations: {
    SET_GOODID: (state, goodid) => {
      state.goodid = goodid
    },
    SET_ORDERID: (state, orderid) => {
      state.orderid = orderid
    },
    SET_STOCKGOODID: (state, stockgoodid) => {
      state.stockgoodid = stockgoodid
    },
    SET_COUPONID: (state, couponid) => {
      state.couponid = couponid
    },
    SET_COUPONGOODLIST: (state, coupongoodlist) => {
      state.coupongoodlist = coupongoodlist
    },
    SET_GOODLIST: (state, goodlist) => {
      state.goodlist = goodlist
    }
  },
  actions: {
    Selectgoodid ({commit}, id) {
      commit('SET_GOODID', id)
    },
    Selectstockgoodid ({commit}, id) {
      commit('SET_STOCKGOODID', id)
    },
    Selectorderid ({commit}, id) {
      commit('SET_ORDERID', id)
    },
    Selectcouponidid ({commit}, id) {
      commit('SET_COUPONID', id)
    },
    Selectcoupongoodlist ({commit}, coupongoodlist) {
      commit('SET_COUPONGOODLIST', coupongoodlist)
    },
    setGoodlist ({ commit }, goodlist) {
      commit('SET_GOODLIST', goodlist)
    }
  }
}
export default goods



// WEBPACK FOOTER //
// ./src/store/modules/goods.js